import { IShoppingCartContext } from '@monofront/types';
import { FREE_SHIPPING_THRESHOLD } from '../constants';
import { useFeatureValue } from '../contexts';
import { computeFreeDeliveryInfos } from '../services';

export const createUseHasReachedFreeDelivery =
  (useShoppingCart: () => IShoppingCartContext) => () => {
    const { shoppingCart } = useShoppingCart();

    const freeDeliveryLimit = useFeatureValue(...FREE_SHIPPING_THRESHOLD);

    return computeFreeDeliveryInfos(
      shoppingCart?.totalPrice ?? 0,
      freeDeliveryLimit,
    );
  };
